<!-- Under maintenance-->
<div class="misc-wrapper">
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="46"
  /></a>
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">{{ data.title }}</h2>
      <p class="mb-3">{{ data.description }}</p>
      <form class="form-inline justify-content-between row m-0 mb-2" action="javascript:void(0);">
        <button
          (click)="deco()"
          class="btn btn-primary mb-1 btn-sm-block"
          type="button"
          rippleEffect
        >
          {{ "Global.deco" | translate }}
        </button>
        <button
          (click)="contact()"
          class="btn btn-primary mb-1 btn-sm-block"
          type="button"
          rippleEffect
        >
          {{ "cloture.nc" | translate }}
        </button>
      </form>
      <img class="img-fluid" src="assets/images/under-main.png" alt="Under maintenance page" />
    </div>
  </div>
</div>
<!-- / Under maintenance-->
